module.exports = __webpack_public_path__ + "img/4 - Andre Nel.132ddd38.jpg";